var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIllustra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 75,
    viewBox: "0 0 94 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.0348 29.4932C72.998 36.2086 61.5571 40.8999 48.2408 40.8999C34.6751 40.8999 23.053 36.0325 18.1683 29.1152",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7018 36.3398C15.7018 46.8748 30.6108 55.4147 48.2408 55.4147C65.8705 55.4147 80.1626 46.8748 80.1626 36.3398",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7367 22.8105L80.1628 36.3413",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6678 21.9112C80.6678 32.4458 66.0997 40.9861 48.1288 40.9861C30.1583 40.9861 15.5897 32.4458 15.5897 21.9112C15.5897 11.3762 30.1583 2.83594 48.1288 2.83594C66.0997 2.83594 80.6678 11.3762 80.6678 21.9112Z",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1509 31.4961V45.8784",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7464 35.8496V50.2323",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.342 38.0977V52.48",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9376 39.7734V54.1557",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5333 40.9004V55.2827",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.129 41.1836V55.5659",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4264 40.9004V55.2827",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7241 40.1934V54.5757",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0218 38.6875V53.0698",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9331 36.498V50.8804",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 33.5703V47.9526",
    stroke: "#108DA0",
    strokeWidth: 0.842697
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0348 29.7285V43.041",
    stroke: "#108DA0",
    strokeWidth: 0.421348
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_840_3027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 57,
    width: 10,
    height: 9
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 57.7246H9.08638V65.3698H0V57.7246Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_840_3027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07597 59.2603L3.77822 63.0491L6.5785 59.8279L2.07597 59.2603ZM3.43525 65.37L0 57.7246L9.08638 58.8698L3.43525 65.37Z",
    fill: "#8F8F8F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.468 11.8761L46.3066 10.843C46.9155 10.813 47.529 10.792 48.1412 10.7979C48.3894 10.7979 48.6371 10.8004 48.884 10.8055L48.8179 11.8424C48.587 11.8378 48.354 11.8361 48.1214 11.8352C47.5724 11.8352 47.0166 11.8491 46.468 11.8761ZM53.4506 12.2571C52.6989 12.1345 51.9279 12.0376 51.1585 11.9689L51.45 10.9442C52.2948 11.02 53.1418 11.1266 53.9676 11.261L53.4506 12.2571ZM41.8829 12.4284L41.272 11.4488C42.0776 11.2912 42.9127 11.1597 43.7554 11.0577L44.1447 12.0719C43.3774 12.1646 42.6161 12.2843 41.8829 12.4284ZM57.7568 13.3016C57.0813 13.0783 56.3769 12.8777 55.6622 12.7046L56.3958 11.7523C57.1808 11.9423 57.9548 12.1631 58.696 12.4079L57.7568 13.3016ZM37.6825 13.5971L36.6611 12.7321C37.3762 12.4666 38.1279 12.2235 38.8939 12.0099L39.7176 12.9394C39.0186 13.1336 38.3343 13.3553 37.6825 13.5971ZM61.4743 14.9076C60.9182 14.5996 60.3224 14.308 59.7038 14.0409L60.833 13.2188C61.5118 13.5121 62.1645 13.8323 62.775 14.1702L61.4743 14.9076ZM34.12 15.3087L32.7523 14.6097C33.3312 14.2541 33.9535 13.9153 34.6037 13.6031L35.807 14.3915C35.2146 14.6755 34.6475 14.9839 34.12 15.3087ZM64.3791 16.9732C63.9746 16.5982 63.5242 16.2337 63.0409 15.8903L64.4937 15.2482C65.0242 15.6245 65.5176 16.0247 65.9621 16.436L64.3791 16.9732ZM31.4098 17.4561L29.7788 16.9665C30.1841 16.5422 30.6409 16.1281 31.136 15.7362L32.6457 16.3354C32.1948 16.6931 31.7789 17.0693 31.4098 17.4561ZM66.2895 19.3738C66.062 18.9545 65.786 18.5391 65.4678 18.1396L67.157 17.717C67.5063 18.1557 67.8101 18.6115 68.0596 19.0717L66.2895 19.3738ZM29.7266 19.9117L27.9304 19.6631C28.1364 19.1955 28.3972 18.7311 28.7048 18.2824L30.4315 18.6549C30.1513 19.0631 29.9141 19.4862 29.7266 19.9117ZM67.0846 21.9658C67.0479 21.5267 66.9628 21.0856 66.8309 20.6554L68.6545 20.4797C68.799 20.9524 68.8926 21.4357 68.933 21.9173L67.0846 21.9658ZM27.3245 22.5318V22.4652C27.3245 22.0081 27.3738 21.5429 27.4694 21.087L29.3069 21.2083C29.2188 21.6242 29.175 22.0489 29.175 22.4699V22.5229L27.3245 22.5318ZM68.5416 24.7965L66.7281 24.5908C66.8827 24.1632 66.9914 23.7237 67.0508 23.2851L68.8955 23.3635C68.8306 23.8446 68.7114 24.3271 68.5416 24.7965ZM27.9834 25.3937C27.7694 24.9289 27.6055 24.4507 27.4959 23.9729L29.3309 23.8406C29.4304 24.2758 29.5799 24.7111 29.775 25.1345L27.9834 25.3937ZM66.8992 27.5344L65.2332 27.0832C65.5728 26.6888 65.8711 26.2784 66.1201 25.8634L67.8737 26.1941C67.6003 26.65 67.2725 27.1009 66.8992 27.5344ZM29.8808 28.0781C29.467 27.655 29.0975 27.2147 28.7823 26.7693L30.5023 26.3868C30.7896 26.7925 31.1263 27.1936 31.503 27.5792L29.8808 28.0781ZM32.8972 30.4181C32.3124 30.0654 31.7617 29.6887 31.2603 29.3002L32.7598 28.6927C33.2166 29.047 33.7188 29.3896 34.2522 29.7115L32.8972 30.4181ZM36.8414 32.2734C36.1226 32.0126 35.4244 31.7231 34.7671 31.4143L35.9566 30.6192C36.5558 30.9011 37.1916 31.1648 37.8472 31.4033L36.8414 32.2734Z",
    fill: "#8F8F8F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9107 26.5754L47.9321 24.4859H42.316L38.1792 21.5836L38.6996 21.2188L42.6206 23.9693H48.2368L51.431 26.2105L50.9107 26.5754Z",
    fill: "#8F8F8F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2408 26.5511C51.3619 26.5511 50.6464 27.0525 50.6464 27.6694C50.6464 28.2858 51.3619 28.7881 52.2408 28.7881C53.1197 28.7881 53.8352 28.2858 53.8352 27.6694C53.8352 27.0525 53.1197 26.5511 52.2408 26.5511ZM52.2408 29.304C50.9561 29.304 49.9108 28.5708 49.9108 27.6696C49.9108 26.7687 50.9561 26.0352 52.2408 26.0352C53.5255 26.0352 54.5709 26.7687 54.5709 27.6696C54.5709 28.5708 53.5255 29.304 52.2408 29.304Z",
    fill: "#8F8F8F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6757 18.2933C41.7967 18.2933 41.0817 18.7947 41.0817 19.4115C41.0817 20.0284 41.7967 20.5302 42.6757 20.5302C43.5546 20.5302 44.2701 20.0284 44.2701 19.4115C44.2701 18.7947 43.5546 18.2933 42.6757 18.2933ZM42.6757 21.0462C41.391 21.0462 40.3461 20.313 40.3461 19.4118C40.3461 18.5109 41.391 17.7773 42.6757 17.7773C43.9604 17.7773 45.0058 18.5109 45.0058 19.4118C45.0058 20.313 43.9604 21.0462 42.6757 21.0462Z",
    fill: "#8F8F8F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5583 26.2363L51.1395 21.7333H45.5233L43.918 20.6075L44.4383 20.2422L45.8284 21.2172H51.4441L58.0782 25.8714L57.5583 26.2363Z",
    fill: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_840_3027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 79,
    height: 75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1686 75H93.5394V0H15.1686V75Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_840_3027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3175 73.0408H93.5296V72.4004H55.3175V73.0408Z",
    fill: "#8F8F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIllustra);
export default __webpack_public_path__ + "static/media/menu_illustra.1da5ec9b4af60c823814009cbe8dfdcd.svg";
export { ForwardRef as ReactComponent };